const handleSubPrincipals = (currentItem, status) => {
	const subPrincipals = currentItem.participant?.subscriptionPrincipals.map(
		(principal) => {
			if (principal) {
				if (principal?.status === "PENDING") {
					return { principalId: principal.principalId, status };
				} else {
					return {
						principalId: principal.principalId,
						status: principal.status,
					};
				}
			}
		}
	);

	return subPrincipals;
};

export default handleSubPrincipals;
